<template>
  <!-- eslint-disable-next-line vue/multi-word-component-names -->
  <div class="login-container">
    <!-- 左侧品牌区域 -->
    <div class="login-brand-section">
      <div class="brand-content">
        <div class="brand-logo" @click="handleLogoClick" style="cursor: pointer;">
          <img :src="$assetUrl(require('../assets/images/homelogo.png'))" alt="ProxyLink logo" style="height: 60px; width: auto;">
        </div>
        <p class="brand-slogan">{{ i18n[currentLanguage].brandSlogan }}</p>
        <!-- <div class="brand-image">
          <div class="image-placeholder">
            <a-icon type="global" :style="{ fontSize: '120px', color: '#1976d2' }" />
          </div>
        </div> -->
        <div class="brand-features">
          <!-- <div class="feature-item">
            <a-icon type="security-scan" :style="{ fontSize: '28px', color: '#1976d2' }" />
            <span>{{ i18n[currentLanguage].featureSecurity }}</span>
          </div>
          <div class="feature-item">
            <a-icon type="wifi" :style="{ fontSize: '28px', color: '#1976d2' }" />
            <span>{{ i18n[currentLanguage].featureSpeed }}</span>
          </div> -->
          <div class="feature-item">
            <a-icon type="global" :style="{ fontSize: '28px', color: '#1976d2' }" />
            <span>{{ i18n[currentLanguage].featureNodes }}</span>
          </div>
          <div class="feature-item">
            <a-icon type="clock-circle" :style="{ fontSize: '28px', color: '#1976d2' }" />
            <span>{{ i18n[currentLanguage].featureSupport }}</span>
          </div>
          <div class="feature-item">
            <a-icon type="cloud" :style="{ fontSize: '28px', color: '#1976d2' }" />
            <span>{{ i18n[currentLanguage].featureLoadBalancing }}</span>
          </div>
          <div class="feature-item">
            <a-icon type="thunderbolt" :style="{ fontSize: '28px', color: '#1976d2' }" />
            <span>{{ i18n[currentLanguage].featureLowLatency }}</span>
          </div>
        </div>
        <p class="brand-tagline">
          {{ i18n[currentLanguage].brandTagline }}
        </p>
        <div class="brand-stats">
          <div class="stat-item">
            <span class="stat-number">100,000+</span>
            <span class="stat-label">{{ i18n[currentLanguage].statUsers }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">99.9%</span>
            <span class="stat-label">{{ i18n[currentLanguage].statUptime }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">5,000+</span>
            <span class="stat-label">{{ i18n[currentLanguage].statNodes }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧注册表单区域 -->
    <div class="login-form-section">
      <div class="form-wrapper">
        <!-- 语言切换 -->
        <div class="language-switcher">
          <span 
            class="lang-tag"
            @click="changeLanguage(currentLanguage === 'zh' ? 'en' : 'zh')"
          >{{ currentLanguage.toUpperCase() }}</span>
        </div>
        
        <h2 class="login-title">{{ i18n[currentLanguage].registerTitle }}</h2>
        <p class="login-subtitle">{{ i18n[currentLanguage].pleaseRegister }}</p>
        
        <a-form
          ref="form"
          :form="form"
          :rules="formRules"
          class="login-form"
        >
          <a-form-item label="" prop="username">
            <a-input
              v-decorator="['username', { initialValue: '' }]"
              size="large"
              :placeholder="i18n[currentLanguage].username"
              class="custom-input"
            >
              <a-icon slot="prefix" type="user" />
            </a-input>
          </a-form-item>

          <a-form-item label="" prop="password">
            <a-input-password
              v-decorator="['password', { initialValue: '' }]"
              size="large"
              :placeholder="i18n[currentLanguage].password"
              class="custom-input"
            >
              <a-icon slot="prefix" type="lock" />
            </a-input-password>
          </a-form-item>

          <a-form-item label="" prop="passwordcheck">
            <a-input-password
              v-decorator="['passwordcheck', { initialValue: '' }]"
              size="large"
              :placeholder="i18n[currentLanguage].confirmPassword"
              class="custom-input"
            >
              <a-icon slot="prefix" type="lock" />
            </a-input-password>
          </a-form-item>

          <a-form-item label="" prop="code">
            <div class="code-container">
              <a-input
                v-decorator="['code', { initialValue: '' }]"
                size="large"
                :placeholder="i18n[currentLanguage].verificationCode"
                class="custom-input"
                style="width: 60%"
              >
                <a-icon slot="prefix" type="scan" />
              </a-input>
              <div class="code-image" @click="getCodeNew">
                <img :src="codeUrl" :alt="i18n[currentLanguage].verificationCode" />
              </div>
            </div>
          </a-form-item>

          <!-- 隐藏字段，默认值 -->
          <a-form-item label="" prop="userType" style="display: none;">
            <a-input
              v-decorator="['userType', { initialValue: 'proxylink' }]"
            >
            </a-input>
          </a-form-item>

          <a-form-item label="" prop="invitation" style="display: none;">
            <a-input
              v-decorator="['invitation', { initialValue: '' }]"
            >
            </a-input>
          </a-form-item>

          <a-form-item label="" prop="rePassword" style="display: none;">
            <a-input
              v-decorator="['rePassword', { initialValue: '' }]"
            >
            </a-input>
          </a-form-item>

          <div class="login-options">
            <a-form-item label="" prop="checked" style="margin-bottom: 0;">
              <a-checkbox :checked="form.getFieldValue('checked')" @change="(e) => form.setFieldsValue({ checked: e.target.checked })" v-decorator="['checked', { initialValue: false }]" class="remember-me">
                {{ i18n[currentLanguage].agreeTerms }}
              </a-checkbox>
            </a-form-item>
          </div>

          <a-form-item>
            <a-button
              type="primary"
              size="large"
              block
              @click="handleSubmit"
              class="login-button"
            >
              {{ i18n[currentLanguage].register }}
            </a-button>
          </a-form-item>

          <a-form-item class="register-link">
            <span>{{ i18n[currentLanguage].hasAccount }}</span>
            <a href="/login" class="register-btn">{{ i18n[currentLanguage].loginNow }}</a>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterView',
  inject: {
    appChangeLanguage: {
      from: 'changeLanguage',
      default: null
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      codeUrl: '',
      currentLanguage: sessionStorage.getItem('userLanguage') === 'zh' ? 'zh' : 'en',
      i18n: {
        zh: {
          registerTitle: '创建账号',
          pleaseRegister: '请填写以下信息完成注册',
          username: '账号',
          password: '密码',
          confirmPassword: '确认密码',
          phone: '手机号',
          email: '邮箱',
          verificationCode: '验证码',
          agreeTerms: '我已阅读并同意服务条款',
          register: '注册',
          hasAccount: '已有账号？',
          loginNow: '立即登录',
          registerSuccess: '注册成功',
          registerFailed: '注册失败',
          passwordRequired: '密码必填',
          usernameRequired: '账号必填',
          phoneRequired: '手机号必填',
          emailRequired: '邮箱必填',
          codeRequired: '验证码必填',
          confirmPasswordRequired: '确认密码必填',
          passwordMismatch: '两次输入的密码不一致',
          termsRequired: '请同意服务条款',
          requestFailed: '注册请求失败',
          getCodeFailed: '获取验证码失败',
          // 左侧品牌区域国际化
          brandSlogan: '连接世界，安全高效',
          featureNodes: '100+国家节点',
          featureSupport: '24/7专业支持',
          featureLoadBalancing: '智能负载均衡',
          featureLowLatency: '低延迟体验',
          brandTagline: '选择ProxyLink，开启您的安全网络之旅',
          statUsers: '活跃用户',
          statUptime: '服务可用性',
          statNodes: '优质节点'
        },
        en: {
          registerTitle: 'Create Account',
          pleaseRegister: 'Please fill in the information below to register',
          username: 'Username',
          password: 'Password',
          confirmPassword: 'Confirm Password',
          phone: 'Phone',
          email: 'Email',
          verificationCode: 'Verification Code',
          agreeTerms: 'I have read and agree to the Terms of Service',
          register: 'Register',
          hasAccount: 'Already have an account?',
          loginNow: 'Login Now',
          registerSuccess: 'Registration Success',
          registerFailed: 'Registration Failed',
          passwordRequired: 'Password is required',
          usernameRequired: 'Username is required',
          phoneRequired: 'Phone is required',
          emailRequired: 'Email is required',
          codeRequired: 'Verification code is required',
          confirmPasswordRequired: 'Confirm password is required',
          passwordMismatch: 'Passwords do not match',
          termsRequired: 'Please agree to the Terms of Service',
          requestFailed: 'Registration request failed',
          getCodeFailed: 'Failed to get verification code',
          // 左侧品牌区域国际化
          brandSlogan: 'Connect the world, safe and efficient',
          featureNodes: '100+ Country Nodes',
          featureSupport: '24/7 Professional Support',
          featureLoadBalancing: 'Smart Load Balancing',
          featureLowLatency: 'Low Latency Experience',
          brandTagline: 'Choose ProxyLink, start your secure network journey',
          statUsers: 'Active Users',
          statUptime: 'Service Availability',
          statNodes: 'Premium Nodes'
        }
      },
      formRules: {
        username: [{ required: true, message: '账号必填', trigger: 'blur' }],
        password: [{ required: true, message: '密码必填', trigger: 'blur' }],
        passwordcheck: [{ required: true, message: '确认密码必填', trigger: 'blur' }],
        code: [{ required: true, message: '验证码必填', trigger: 'blur' }]
      }
    };
  },
  mounted() {
    this.getCodeNew();
    // 初始化时提取邀请码
    let searchParams = new URLSearchParams(window.location.search);
    let invitation = searchParams.get('invitation');
    this.form.setFieldsValue({ invitation: invitation || null });
  },
  methods: {
    handleLogoClick() {
      this.$router.push('/');
    },
    changeLanguage(language) {
      this.currentLanguage = language;
      sessionStorage.setItem('userLanguage', language);
      if (this.appChangeLanguage) {
        this.appChangeLanguage(language);
      }
      this.updateFormRules();
    },
    updateFormRules() {
      this.formRules = {
        username: [{ required: true, message: this.i18n[this.currentLanguage].usernameRequired, trigger: 'blur' }],
        password: [{ required: true, message: this.i18n[this.currentLanguage].passwordRequired, trigger: 'blur' }],
        passwordcheck: [{ required: true, message: this.i18n[this.currentLanguage].confirmPasswordRequired, trigger: 'blur' }],
        code: [{ required: true, message: this.i18n[this.currentLanguage].codeRequired, trigger: 'blur' }]
      };
    },
    getCodeNew() {
      this.$request.get('/auth/captcha', { responseType: 'arraybuffer' })
        .then(res => {
          if (res.status === 200) {
            const base64 = btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            this.codeUrl = `data:image/png;base64,${base64}`;
          }
        })
        .catch(err => {
          console.error('获取验证码失败:', err);
          this.$message.error(this.i18n[this.currentLanguage].getCodeFailed);
        });
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.password !== values.passwordcheck) {
            this.$message.warning(this.i18n[this.currentLanguage].passwordMismatch);
            return;
          }
          if (!values.checked) {
            this.$message.warning(this.i18n[this.currentLanguage].termsRequired);
            return;
          }

          const visitLogId = localStorage.getItem('PROMO_VISIT_LOG_ID'); // 获取日志ID
          
          // 提交注册请求，使用正确的字段名
          this.$request.post('/auth/register', {
            username: values.username,
            password: values.password,
            passwordcheck: values.passwordcheck,
            code: values.code,
            invitation: values.invitation,
            visitLogId: visitLogId,
            userType: values.userType,
            rePassword: '' // 保持空字符串，根据提供的参数要求
          })
            .then(res => {
              if (res.data.code === 200) {
                // 注册成功，清理战场
                localStorage.removeItem('PROMO_VISIT_LOG_ID');
                sessionStorage.removeItem(`VISIT_LOGGED_${values.invitation}`);
                this.$message.success(this.i18n[this.currentLanguage].registerSuccess);
                this.$router.push('/login');
              } else {
                this.$message.warning(this.i18n[this.currentLanguage].registerFailed);
                this.getCodeNew();
              }
            })
            .catch(err => {
              console.error('注册请求失败:', err);
              this.$message.error(this.i18n[this.currentLanguage].requestFailed);
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  min-height: 100vh;
  height: auto;
  overflow-y: auto;
}

body, html {
  margin: 0;
  padding: 0;
  background: white;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.login-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.login-brand-section {
  flex: 1;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  position: relative;
  overflow: hidden;
}

.brand-content {
  text-align: center;
  color: #212121;
  z-index: 1;
  max-width: 500px;
}

.brand-logo {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 16px;
  letter-spacing: 2px;
  opacity: 1;
  color: #1976d2;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.brand-slogan {
  font-size: 20px;
  margin-bottom: 24px;
  opacity: 1;
  font-weight: 500;
  color: #424242;
}

.brand-image {
  margin: 30px 0;
}

.image-placeholder {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  background: rgba(25, 118, 210, 0.12);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(25, 118, 210, 0.2);
  animation: pulse 3s ease-in-out infinite;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.brand-description {
  font-size: 16px;
  line-height: 1.8;
  opacity: 1;
  margin-bottom: 24px;
  text-align: justify;
  color: #333;
}

.brand-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin: 32px 0;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background: rgba(25, 118, 210, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(25, 118, 210, 0.2);
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.feature-item:hover {
  transform: translateY(-4px);
  background: rgba(25, 118, 210, 0.15);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.feature-item span {
  font-size: 16px;
  font-weight: 600;
  color: #212121;
}

.brand-tagline {
  font-size: 18px;
  font-weight: 600;
  margin-top: 32px;
  color: #1976d2;
  opacity: 1;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.brand-stats {
  display: flex;
  justify-content: space-around;
  margin-top: 40px;
  padding-top: 32px;
  border-top: 1px solid rgba(25, 118, 210, 0.25);
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  color: #1976d2;
  opacity: 1;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-label {
  font-size: 14px;
  color: #424242;
  font-weight: 500;
  opacity: 1;
}

.login-form-section {
  flex: 1;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  overflow-y: auto;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}

.form-wrapper {
    width: 100%;
    max-width: 450px;
    background: white;
    padding: 40px;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    animation: fadeInUp 0.6s ease-out;
    position: relative;
  }

  .language-switcher {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10;
  }

  .lang-tag {
    display: inline-block;
    padding: 4px 8px;
    background: #f5f5f5;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    color: #999;
    cursor: pointer;
    transition: all 0.2s ease;
    letter-spacing: 1px;
  }

  .lang-tag:hover {
    background: #1976d2;
    color: #fff;
  }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  text-align: center;
}

.login-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 32px;
  text-align: center;
}

.login-form {
  width: 100%;
}

.custom-input {
  border-radius: 8px;
  border: 1px solid #eaecef;
  transition: all 0.3s ease;
}

.custom-input:focus {
  border-color: #64b5f6;
  box-shadow: 0 0 0 2px rgba(100, 181, 246, 0.1);
}

.code-container {
  display: flex;
  gap: 15px;
  align-items: center;
  margin-bottom: 16px;
}

.code-image {
  width: 45%;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #eaecef;
  background-color: #fafbfc;
  transition: all 0.3s ease;
}

.code-image:hover {
  border-color: #64b5f6;
  transform: translateY(-2px);
}

.code-image img {
  width: 100%;
  height: 44px;
  object-fit: contain;
  padding: 6px;
  background-color: #fff;
}

.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  font-size: 14px;
}

.remember-me {
  color: #666;
}

.forgot-password {
  color: #64b5f6;
  text-decoration: none;
  transition: color 0.3s ease;
}

.forgot-password:hover {
  color: #1976d2;
}

.login-button {
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #64b5f6 0%, #1976d2 100%);
  border: none;
  transition: all 0.3s ease;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(100, 181, 246, 0.4);
}

.register-link {
  text-align: center;
  margin-top: 24px;
  font-size: 14px;
  color: #666;
}

.register-btn {
  color: #64b5f6;
  font-weight: 600;
  margin-left: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.register-btn:hover {
  color: #1976d2;
}

@media (max-width: 992px) {
  .login-container {
    flex-direction: column;
  }

  .login-brand-section {
    flex: none;
    height: auto;
    min-height: auto;
    padding: 30px;
  }

  .login-form-section {
    border-left: none;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding: 30px 0;
  }

  .brand-logo {
    font-size: 42px;
  }

  .brand-slogan {
    font-size: 20px;
  }

  .image-placeholder {
    width: 180px;
    height: 180px;
  }

  .brand-image .a-icon {
    font-size: 100px !important;
  }

  .brand-features {
    grid-template-columns: 1fr;
    gap: 16px;
    margin: 24px 0;
  }

  .feature-item {
    padding: 16px;
  }

  .feature-item .a-icon {
    font-size: 24px !important;
  }

  .brand-stats {
    margin-top: 32px;
    padding-top: 24px;
  }

  .stat-number {
    font-size: 28px;
  }

  .stat-label {
    font-size: 13px;
  }

  .form-wrapper {
    max-width: 100%;
    margin: 0 20px;
    padding: 40px 30px;
  }
}

@media (max-width: 768px) {
  .login-brand-section {
    display: none;
  }

  .login-container {
    justify-content: center;
    align-items: center;
    padding: 20px 0;
  }

  .login-form-section {
    flex: none;
    width: 100%;
    padding: 0;
    border-top: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .form-wrapper {
    margin: 0 15px;
    padding: 40px 24px;
    max-width: 500px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border-radius: 16px;
  }

  .login-title {
    font-size: 28px;
    margin-bottom: 12px;
  }

  .login-subtitle {
    font-size: 14px;
    margin-bottom: 32px;
  }

  .code-container {
    flex-direction: column;
    align-items: stretch;
  }

  .code-image {
    width: 100%;
    margin-top: 12px;
  }

  .code-image img {
    height: 50px;
  }

  .login-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .login-brand-section {
    display: none;
  }

  .form-wrapper {
    margin: 0 10px;
    padding: 30px 20px;
  }

  .login-title {
    font-size: 24px;
  }

  .login-subtitle {
    font-size: 13px;
    margin-bottom: 28px;
  }

  .custom-input {
    font-size: 14px;
  }

  .login-button {
    height: 44px;
    font-size: 15px;
  }
}
</style>
